import get from 'lodash/get';
import {useEffect,useState} from 'react';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import selectCurrentUser from '../../redux/selectors/selectCurrentUser';
import {
  useGetCurrentProviderQuery,
  useUpdateProviderMutation
} from '../../redux/services/providerApi';
import AppDashboard from '../AppDashboard';
import useError from '../../hooks/useError';
import AccountSettingsScreen from '../../components/providers/AccountSettingsScreen';
import LoadingScreen from '../../components/common/LoadingScreen';

const handleSubmit = ({
  props,
  setError,
  provider,
  updateProvider,
  navigate
}) => async (formData) => {
  const {error} = await updateProvider({
    id: get(provider, 'id'),
    body: formData
  });
  if (error) {
    return setError({message: get(error, 'data.errors', 'Unknown error')});
  }
  setTimeout(() => navigate('/providers/settings'), 250);
};

const AccountSettingsPage = props => {
  const navigate = useNavigate();
  const [updateProvider] = useUpdateProviderMutation();
  const providerQuery = useGetCurrentProviderQuery({refetch: true, skip: false});
  const errors = useError();
  const setError = errors.create;
  const provider = get(providerQuery, 'data', null);
  useEffect(() => {
    providerQuery.refetch();
  }, []);
  const childProps = {
    ...props,
    setError: err => errors.create(err),
    provider,
    onSubmit: handleSubmit({props, setError, updateProvider, navigate, provider}),
  };
  if (providerQuery.isFetching) return <LoadingScreen />;
  return (
    <AppDashboard
      title='Settings'
      loading={!provider}
      onBack={() => navigate('/providers/settings')}
      hideBack={true}
    >
        <AccountSettingsScreen {...childProps} />
    </AppDashboard>
  );
};

const mapState = state => ({
  user: selectCurrentUser()(state),
});

const mapDispatch = () => ({});

export default connect(mapState,mapDispatch)(AccountSettingsPage);
